import { combineReducers } from '@reduxjs/toolkit';

import { appStateReducer } from './appStateSlice';
import { userProfileReducer } from './userProfileSlice';
import { documentsReducer } from './documentsSlice';

const rootReducer = combineReducers({
  appState: appStateReducer,
  userProfile: userProfileReducer,
  documents: documentsReducer,
});

export default rootReducer;
